import React,{useEffect,useState} from 'react'
import {URL} from '../Helper/helper'
import loader from '../Img/loader.gif'
import { invokeTrainers } from '../ServiceCalls/ApiCalls';
import './TrainersComponent.css'

function TrainersComponent() {


  const[trainers,setTrainers]= useState([])

  useEffect(() =>{

    async function getTrainers(){
        const trainer_list = await invokeTrainers();
        setTrainers([...trainer_list])
    }

    getTrainers()

  },[])


  return (
    <div>
          <section id="our-team">
              <div class="container">
                  <div class="section-header">
                      <h2 class="section-title wow fadeInDown">
                        Coaches
                      </h2>
                      <p class="wow fadeInDown">Only coaches who have met our standards are selected. Our coaches are passionate about developing others.Our coaches want you to have a great time too! Want to learn how to do a smash shot just to look cool? Just say it and they’ll be so excited to teach you!</p>
                  </div>


                  <div class="row d-flex flex-row justify-content-center"> 
                    {
                    trainers.length > 0 ?
                        trainers.map((trainer,idx) =>{
                            
                        //if(trainer?.profile_pic?.data?.data)
                            const blob = trainer?.profile_pic?.data?.data ? new Blob([Int8Array.from(trainer?.profile_pic?.data?.data)], {type: trainer?.profile_pic?.contentType }) : null;
                            const image = blob ? window.URL.createObjectURL(blob) : null;
                        
        
                        //console.log('Img',{image})
                        return <div class="col-md-3 col-sm-6 col-xs-12" key={idx}>
                                <div class="team-member wow fadeInUp" data-wow-duration="400ms" data-wow-delay="0ms">
                                    <div class="team-img">
                                        <img class="img-responsive" loading="lazy" src={image} alt={trainer?.trainer_name}/>
                                    </div>
                                    <div class="team-info">
                                        <h3 className='text-center'>{trainer?.trainer_name}</h3>
                                        <span id='trainer-desig'>{trainer?.designation}</span>
                                    </div>
                                    <ul class="social-icons">
                                        <li className='text-center'><a href="#"><i className="fa fa-facebook"></i></a></li>
                                        <li className='text-center'><a href="#"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                        <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        }

                        )
                        :
                        <div className="col-md-12 col-sm-12">
                            <div className="loader-container">
                                <img src={loader} className="loader" alt="loader" />
                            </div>
                        </div>
                        // <div>
                        //     <h4 className='text-center text-secondary'>Loading Coaches...</h4>
                        // </div>
                    }
                     
                  </div>

              </div>
          </section>
    </div>
  )
}

export default TrainersComponent